import Vue from 'vue';
import Router from 'vue-router';
import Layout from '@/layout/index';
import Index from '@/pages/index';
import productCate from '@/pages/productCate';
import Product from '@/pages/product';
import Business from '@/pages/business';
import Service from '@/pages/service';
import About from '@/pages/about';
import NewBusiness from '@/pages/newBusiness';
import NewConsult from '@/pages/newConsult';
import NewDetails from '@/pages/NewDetails';
import Join from '@/pages/join';

Vue.use(Router)

export default new Router({
  mode: 'history', // require service support
  routes: [
    {
      path: '/',
      component: Layout,
      redirect: '/index',
      children: [
        {
          path: '/index',
          name: 'Index',
          component: Index
        },
        {
          path: '/product/cate/:id(\\d+)/:tlId',
          // path: '/product/:type/:id',
          name: 'productCate',
          component: productCate
        },
        {
          path: '/product/details/:id(\\d+)/:tlId',
          // path: '/product/:type/:id',
          name: 'Product',
          component: Product
        },
        {
          path: '/business/:id(\\d+)/:tlId',
          name: 'Business',
          component: Business
        },
        {
          path: '/service',
          name: 'Service',
          component: Service
        },
        {
          path: '/about',
          name: 'About',
          component: About
        },
        {
          path: '/new/business',
          name: 'NewBusiness',
          component: NewBusiness
        },
        {
          path: '/new/consult',
          name: 'NewConsult',
          component: NewConsult
        },
        {
          path: '/new/details/:id',
          name: 'NewDetails',
          component: NewDetails
        },
        {
          path: '/join',
          name: 'Join',
          component: Join
        }
      ]
    },
    // {
    //   path: '/index2',
    //   name: 'Index',
    //   component: Index
    // },
    // {
    //   path: '/product/cate/:id(\\d+)/:tlId',
    //   // path: '/product/:type/:id',
    //   name: 'productCate',
    //   component: productCate
    // },
    // {
    //   path: '/product/details/:id(\\d+)/:tlId',
    //   // path: '/product/:type/:id',
    //   name: 'Product',
    //   component: Product
    // },
    // {
    //   path: '/business/:id(\\d+)/:tlId',
    //   name: 'Business',
    //   component: Business
    // },
    // {
    //   path: '/service',
    //   name: 'Service',
    //   component: Service
    // },
    // {
    //   path: '/about',
    //   name: 'About',
    //   component: About
    // },
    // {
    //   path: '/new/business',
    //   name: 'NewBusiness',
    //   component: NewBusiness
    // },
    // {
    //   path: '/new/consult',
    //   name: 'NewConsult',
    //   component: NewConsult
    // },
    // {
    //   path: '/new/details/:type/:id',
    //   name: 'NewDetails',
    //   component: NewDetails
    // },
    // {
    //   path: '/join',
    //   name: 'Join',
    //   component: Join
    // }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js